export const findIndexByKey = (array, value, key = 'id') => array.findIndex((item) => item[key] === value);

export const flattenArray = (arr) => arr.reduce(
  (acc, val) => Array.isArray(val) ? acc.concat(flattenArray(val)) : acc.concat(val),
  [],
);

export const findByKey = (array, value, key = 'id') => {
  let index = -1;
  if (typeof value === 'number') {
    index = array.findIndex((item) => +item[key] === +value);
  } else {
    index = array.findIndex((item) => item[key] === value);
  }
  return index === -1 ? undefined : array[index];
};

export const deleteByKey = (array, value, key = 'id') => {
  const index = array.findIndex((item) => item[key] === value);
  const newArray = [...array];
  newArray.splice(index, 1);
  return newArray;
};

export const getUniqueValuesArray = (arr) => {
  const tempArr = arr.map((item) => JSON.stringify(item));
  const uniqueArr = [...new Set(tempArr)].map((item) => JSON.parse(item));
  return uniqueArr;
};
